import type { ISignedReport } from '@services/types';

import { REPORT_KEY } from './constants';

export const getSessionReport = (poNumber: string): ISignedReport | null => {
  const data = sessionStorage.getItem(`${REPORT_KEY}_${poNumber}`);

  if (!data) {
    return null;
  }

  try {
    const parsed: ISignedReport = JSON.parse(data);

    if (Date.now() < parsed.expires) {
      return parsed;
    }

    sessionStorage.removeItem(REPORT_KEY);

    return null;
  } catch {
    sessionStorage.removeItem(REPORT_KEY);

    return null;
  }
};

export const storeSessionReport = (poNumber: string, report: ISignedReport) => {
  sessionStorage.setItem(`${REPORT_KEY}_${poNumber}`, JSON.stringify(report));
};

export const clearSessionReport = (poNumber: string) => {
  sessionStorage.removeItem(`${REPORT_KEY}_${poNumber}`);
};
